<template>
  <Modal :activeModal="activeModal" @closeModal="closeModal">
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
        Relatório Lançamento de Caixa (Créditos)
        <v-spacer></v-spacer>
        <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <v-container fluid class="pb-0">
        <v-col>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col class="pa-3 pt-0 pb-1">
                  <!-- Periodo: {{ rangeDate.dtInicial | data('DD/MM/YYYY') }} a {{ rangeDate.dtFinal | data }} -->
                  <strong>Data de Referência:</strong> {{ date }}
                </v-col>

                <v-col class="text-right pa-3 pt-0 pb-1">
                  <strong>Revendedor:</strong> {{ revendedor }} 
                </v-col>
              </v-row>

              <v-row class="align-end">
                <v-col class="pa-3 pt-0 pb-1">
                  <date />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-container>

      <v-col class="d-flex justify-center align-center" style="min-height: 300px; width: 100%;" v-if="loadingModal">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-col>

      
      <v-container fluid class="mt-0" v-else>
        <v-col>
          <div class="box-table">
            <v-data-table
              :headers="headers"
              :items="listMovimentos"
              :items-per-page="5"
              width="300px"
              height="auto"
              flat
              dense
            >
              <template v-slot:item.value="{ item }">
                {{ item.total | currency }}
              </template>

              <template v-slot:item.description="{ item }">
                {{ item.description }} ({{item.time}})
              </template>


              <template slot="body.append">
                <tr class="">
                  <th>Total: </th>
                  <th>{{ total | currency }}</th>

                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-container>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
// import { required } from 'vuelidate/lib/validators'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'
import date from '@/views/components/date'
import moment from 'moment'

import validacao from './validacao'

export default {
  name: 'ModalCaixa',
  mixins: [validationMixin],
  components: {
    // HeaderModal: () => import('@/views/components/headerModal')
    Modal: () => import('@/views/components/modal'),
    date
  },
  data: () => ({
    activeModal: false,
    loading: false,
    entityId: null,
    dtFinal: null,
    dtInicial: null,
    lotteryGuesses: null,
    lotteryGames: null,
    loadingModal: false,
    nrJogo: null,
    revendedor: '',
    date: '',
    headers: [
      { sortable: false, class: 'table-header', text: 'Descrição', value: 'description' },
      { sortable: false, class: 'table-header', text: 'Valor', value: 'value' },
    ]
  }),
  
  computed: {
    ...mapGetters('relatorioGecomHome', ['totalItens','listMovimentos']),
    ...validacao,
    variables: () => variables,
    isEdit () {
      return this.item.id ? !!1 : !!0
    },

    total () {
      return this.listMovimentos.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.total)
      }, 0)      
    }
  },
  mounted () {
    Events.$on('modal::historicoVendas::movimentos', (e) => {
      this.activeModal = true
      this.date = this.displayDate(e.data, e.hasMonthOrDate)
      this.revendedor = e.entity.entity_cod

      this.loadingModal = true

      this.formatDate(e)

      this.getMovimentos({
        date: e.data,
        entityId: e.entity.entity_id
      })
      .finally(() => this.loadingModal = false)
    })
  },
  methods: {
    ...mapActions('relatorioGecomHome', ['getMovimentos', 'limparItem']),
    openModal () {
      this.activeModal = true
    },

    closeModal () {
      this.activeModal = false
      this.limparItem()
    },

    formatDate (data) {
      if (data.hasMonthOrDate === 2) {
        this.dtInicial = moment(data.data).startOf('month').format('YYYY-MM-DD')
        this.dtFinal = moment(data.data).endOf('month').format('YYYY-MM-DD')

        return
      } 

      this.dtInicial = moment(data.data).format('YYYY-MM-DD')
      this.dtFinal = moment(data.data).format('YYYY-MM-DD')
    },

    displayDate (date, type) {
      if (type === 2) return moment(date).format('MM/YYYY')

      return moment(date).format('DD/MM/YYYY')
    }
  },

  beforeDestroy () {
    Events.$off('modal::historicoVendas::movimentos')
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/formularios';
  @import '~@/assets/styles/components/modal-cadastro';
</style>